// The game's version, in one place. Both the client (lobby banner + in-game corner) and
// the server import this; package.json's `version` is kept in lock-step and check.js
// fails the build if the two ever drift. Bump this and the tag together.
export const VERSION = "0.6.0-alpha";
